/** @format */

import {styled} from '@mui/material/styles';
import {Rating} from '@mui/material';

export const StyledRating = styled(Rating)(({theme}) => ({
  gap: theme.spacing(1.5),

  '.MuiRating-icon .MuiSvgIcon-root': {
    fontSize: '24px',
  },

  '.MuiRating-iconEmpty': {
    color: theme.palette.figma_gray_middle_dark?.dark,
  },

  '.MuiRating-iconFilled': {
    color: theme.palette.figma_primary?.dark,
  },

  'label:hover .MuiRating-iconFilled': {
    color: theme.palette.figma_primary?.main,
  },
}));
